import React from 'react';
import { Hero } from '../components/Hero';
import { Agitation } from '../components/Agitation';
import { HiddenCosts } from '../components/HiddenCosts';
import { Solution } from '../components/Solution';
import { SocialProof } from '../components/SocialProof';
import { FaqSection } from '../components/FaqSection';
import { Scarcity } from '../components/Scarcity';
import { FinalCta } from '../components/FinalCta';
import { SiteFooter } from '../components/SiteFooter';
export function Landing() {
  return <div className="w-full bg-canvas font-sans text-forest" data-id="element-172" data-mp="3gapimua86hl">
      <main data-id="element-173" data-mp="87sr9d44qb3m">
        <Hero data-id="element-174" data-mp="882jz8gk6wd0" />
        <SocialProof data-id="element-175" data-mp="87kctgscyxqb" />
        <Agitation data-id="element-176" data-mp="893tv9lu9ct5" />
        <HiddenCosts data-id="element-177" data-mp="88lysgawx4mt" />
        <Solution data-id="element-178" data-mp="c9eb5if2zpnb" />
        <FaqSection data-id="element-179" data-mp="c9xiy6b0oxnm" />
        <Scarcity data-id="element-180" data-mp="c8coegopdepr" />
        <FinalCta data-id="element-181" data-mp="c8w8o41tsf6y" />
      </main>
      <SiteFooter data-id="element-182" data-mp="h8ijy7y3fld4" />
    </div>;
}